export default __webpack_public_path__ + "static/media/light.cd8838c5.woff2";